// const API = "http://localhost:8080.com/api";
const API = "https://zoeked.com/api";
// import queryString from "query-string";


export const sendMessage = (message) => {
    return fetch(`${API}/mail/sendmail`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(message)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};


export const getIOTData = () => {
    // return fetch(`${API}/iot/readsensordata`, {
    // return fetch(`http://localhost:8080/api/iot/readsensordata`, {
    return fetch(`https://zoeked.com/api/iot/readsensordata`, {
        method: "GET",
        headers: {            
            "Content-Type": "application/json"
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
};